import { render, staticRenderFns } from "./GoTop.vue?vue&type=template&id=4791c390&"
import script from "./GoTop.vue?vue&type=script&lang=ts&"
export * from "./GoTop.vue?vue&type=script&lang=ts&"
import style0 from "./GoTop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports